// DS: i3.40 Studio Playground
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioPlayground: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.34 5.75a5.02 5.02 0 0 1-3.32-3.31.26.26 0 0 0-.5 0 5.02 5.02 0 0 1-3.33 3.31.26.26 0 0 0 0 .5c1.58.5 2.83 1.7 3.33 3.31.08.25.41.25.5 0a5.02 5.02 0 0 1 3.32-3.31c.21-.08.21-.42 0-.5Zm-6.88 4.84a3.37 3.37 0 0 1-2.25-2.21.18.18 0 0 0-.34 0 3.37 3.37 0 0 1-2.24 2.2.17.17 0 0 0 0 .34 3.37 3.37 0 0 1 2.24 2.2c.06.17.29.17.34 0a3.37 3.37 0 0 1 2.25-2.2c.14-.06.14-.28 0-.33Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.74 11.5a7.91 7.91 0 0 1 3.45 3.17l4.56-5.1c2.25-2.82-.86-4.8-2.98-2.84l-5.03 4.77Z"
        />
        <path d="M16.06 15.87c1.23 3.92-4.09 7.67-10.04 4.52a.43.43 0 0 1 .04-.77c.69-.31 1.58-1.05 2.03-2.76.8-3.02 3.17-5.01 5.41-3.94a4.42 4.42 0 0 1 2.56 2.95Z" />
      </svg>
    </IconWrap>
  );
};
StudioPlayground.displayName = 'StudioPlayground';

export default StudioPlayground;
